import React from "react";
import { generateIssueColumns } from "../../helper";
import {
  alpha,
  Box,
  InputBase,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import DataTableComponent from "../../../../components/common/DataTable/DataTable";
import issue from "../../../../assets/svg/issue.svg";
import SearchIcon from "@mui/icons-material/Search";
import SimpleBar from "simplebar-react";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  // width: "230px",
  height: "40px",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(1),
    // width: "auto",
  },
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "230px",
    // [theme.breakpoints.up("sm")]: {
    //   width: "12ch",
    //   "&:focus": {
    //     width: "20ch",
    //   },
    // },
  },
}));

const issueData = [
  {
    id: 1,
    date: "Thu, Aug 17 2023",
    image: "http://dummyimage.com/168x100.png/dddddd/000000",
    user: "Arlene McCoy",
    user_loction: "India",
    issue_type: "My main address was blocked",
    note: "dr",
  },
  {
    id: 2,
    date: "Thu, Aug 17 2023",
    image: "http://dummyimage.com/168x100.png/dddddd/000000",
    user: "Arlene McCoy",
    user_loction: "India",
    issue_type: "My main address was blocked",
    note: "dr",
  },
  {
    id: 3,
    date: "Thu, Aug 17 2023",
    image: "http://dummyimage.com/168x100.png/dddddd/000000",
    user: "Arlene McCoy",
    user_loction: "India",
    issue_type: "My main address was blocked",
    note: "dr",
  },
  {
    id: 4,
    date: "Thu, Aug 17 2023",
    image: "http://dummyimage.com/168x100.png/dddddd/000000",
    user: "Arlene McCoy",
    user_loction: "India",
    issue_type: "My main address was blocked",
    note: "dr",
  },
  {
    id: 5,
    date: "Thu, Aug 17 2023",
    image: "http://dummyimage.com/168x100.png/dddddd/000000",
    user: "Arlene McCoy",
    user_loction: "India",
    issue_type: "My main address was blocked",
    note: "dr",
  },
];

function IssueComponent() {
  const issueColumns = generateIssueColumns();

  const [searchValue, setSearchValue] = React.useState("");

  const filteredRows = issueData?.filter((row) => {
    const includesTerm = row.user
      .toLowerCase()
      .includes(searchValue.toLowerCase());
    return includesTerm;
  });

  return (
    <>
      <Box
        sx={{
          margin: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ p: "24px 16px", paddingLeft: "0px" }}>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </Search>
          </Box>
        </Box>
        {filteredRows?.length > 0 && (
          <SimpleBar
            forceVisible="x"
            autoHide={true}
            style={{
              overflowX: "auto",
              maxHeight: "63vh",
            }}
            className="custom-scrollbar"
          >
            <Box sx={{ display: "contents" }}>
              <Paper
                sx={{
                  width: "100%",
                  // height: "75vh",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                }}
              >
                <DataTableComponent
                  data={filteredRows || []}
                  columns={issueColumns}
                />
              </Paper>
            </Box>
          </SimpleBar>
        )}
        {filteredRows && filteredRows.length <= 0 && (
          <Box sx={{ marginTop: "10%" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img src={issue} alt="issue_not_found" />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                No records found
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}

export default IssueComponent;
